import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";

export interface ObservationType {
  code: string;
  color: string;
  negativeColor: string;
  label: string;

  frame: string;
  params?: Array<ParamType>;
  negativeTags?: Array<CodeLabel>;
}

export interface CodeLabel {
  code: string;
  label: string;
}

export interface ParamOption {
  code: string;
  label: string;
}

export interface ParamType {
  code: string;
  label: string;
  defaultOpt?: string;
  required?: boolean;
  options: Array<ParamOption>;
}

export interface Option {
  code: string;
}

export interface PartParamType {
  code: string;
  options: Array<Option>;
}

export default class GrammarApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new GrammarApi(axios);
  }

  getObservationTypes(): Promise<ObservationType[]> {
    return this.client.get("/observation-types").then((resp) => resp.data);
  }

  getParamTypes(): Promise<ParamType[]> {
    return this.client.get("/param-types").then((resp) => resp.data);
  }

  getPartParamTypes(): Promise<PartParamType[]> {
    return this.client.get("/part-param-types").then((resp) => resp.data);
  }
}
